import { INACTIVE } from 'config/constants';
import {
	IAddUpdateBasketPromoState,
	IAddUpdateDynamicPromoState,
	IAddUpdateVolumetricPromoState,
	IDynamicPromoDetailResponseNormalized,
	IGetCustomerNewDetailResponse,
	IPromoProductSearchNormalized,
	IVolumetricPromoDetailResponseNormalized,
	IVolumetricPromoDiscountSlabs,
	IAddUpdateUserLevelPromoState,
} from 'interfaces/Index';
import { normalizePromoProductSearchResult } from 'normalizer/GlobalProductNormalizer';
import { getCustomerDetailsNewApiCall } from 'redux/sources/CustomerSource';
import {
	fetchActiveProductWithPromoCityLevelApiCall,
	fetchProductsForPromoCityLevelApiCall,
} from 'redux/sources/PromoCityLevelSource';
import { PROMO_SLAB_LEVEL } from '../constants/PromosCityLevelConstants';

export const doProductAPIsearch = async (
	val: any,
	setProductData: any,
	setProductLoading: any,
	cityId: string
) => {
	setProductLoading(true);
	const productData: any = await fetchProductsForPromoCityLevelApiCall(cityId, {
		searchKey: val,
		pageSize: '25',
		sortColumn: 'title',
		sortDirection: 'ASC',
		channel: 'CUSTOMER_APP',
	});
	const productsWithActivePromos: string[] = await fetchActiveProductWithPromoCityLevelApiCall(
		cityId
	);
	if (productData && productData.productData) {
		const filteredData = productData.productData.filter((product: any) => {
			return product.status !== INACTIVE;
		});
		let normalizedProducts: IPromoProductSearchNormalized[] = normalizePromoProductSearchResult(
			filteredData,
			productsWithActivePromos
		);
		setProductData(normalizedProducts);
		setProductLoading(false);
	}
};

export const searchAndSetProductPrice = async (productId: string) => {
	// TODO: Product data Old Api removed will be replaced with new API in the future
	return '';
};

export const closeUserLevelModal = (setIsShowUserLevelModal: any, showStoreModal: boolean) =>
	setIsShowUserLevelModal(false);

export const setCreatedAndUpdateUser = async (
	details: IVolumetricPromoDetailResponseNormalized | IDynamicPromoDetailResponseNormalized,
	setCreatedByUser: any,
	setUpdatedByUser: any
) => {
	if (details.createdBy === details.updatedBy) {
		const userInfo: IGetCustomerNewDetailResponse = await getCustomerDetailsNewApiCall(
			details.createdBy
		);
		setCreatedByUser(userInfo ? userInfo.fullName : '');
		setUpdatedByUser(userInfo ? userInfo.fullName : '');
		return;
	}
	const createUserInfo: IGetCustomerNewDetailResponse = await getCustomerDetailsNewApiCall(
		details.createdBy
	);
	const updateUserInfo: IGetCustomerNewDetailResponse = await getCustomerDetailsNewApiCall(
		details.updatedBy
	);
	setCreatedByUser(createUserInfo ? createUserInfo.fullName : '');
	setUpdatedByUser(updateUserInfo ? updateUserInfo.fullName : '');
};

export const mapSlabsFromDiscount = (
	slabs: IVolumetricPromoDiscountSlabs[],
	productPrice: any,
	volumetricPromoState: IAddUpdateVolumetricPromoState
) => {
	const slabState = volumetricPromoState.slabs.slice();
	for (let i = 0; i < PROMO_SLAB_LEVEL; i++) {
		if (slabs[i]) {
			slabState[i].minUnits = slabs[i].minimumUnits.toString();
			slabState[i].discountPerUnit = slabs[i].discount.toString();
			slabState[i].isAgreementCheck = true;
			slabState[i].discountedUnitPrice = Number(productPrice) - slabs[i].discount;
		}
	}
	return slabState;
};

export const validateSlabs = (volumetricPromoState: IAddUpdateVolumetricPromoState) => {
	let isSlabOneValid: boolean = false;
	let isSlabTwoValid: boolean = false;
	let isSecondSlabApplied: boolean = false;
	volumetricPromoState.slabs.forEach((slab, index: number) => {
		if (index === 0) {
			isSlabOneValid =
				(slab.discountPerUnit as string).length > 0 &&
				(slab.minUnits as string).length > 0 &&
				slab.isAgreementCheck;
		} else {
			isSecondSlabApplied =
				(slab.discountPerUnit as string).length > 0 || (slab.minUnits as string).length > 0;
			isSlabTwoValid =
				(slab.discountPerUnit as string).length > 0 &&
				(slab.minUnits as string).length > 0 &&
				slab.isAgreementCheck;
		}
	});
	if (isSlabOneValid) {
		if (isSecondSlabApplied) {
			if (isSlabTwoValid) {
				return true;
			}
			return false;
		}
		return true;
	}
	return false;
};

export const validateBasketPromo = (basketState: IAddUpdateBasketPromoState) => {
	return (
		basketState.basketCategories &&
		basketState.discountValue &&
		basketState.isAgreementCheck &&
		basketState.minOrderValue &&
		basketState.customerChannels.length > 0
	);
};

export const validateDynamicPromo = (dynamicState: IAddUpdateDynamicPromoState) => {
	return dynamicState.isAgreementCheck && dynamicState.customerChannels.length > 0;
};

export const validateUserLevelPromo = (userLevelPromoState: IAddUpdateUserLevelPromoState) => {
	return (
		userLevelPromoState.isAgreementCheck &&
		userLevelPromoState.isUserLevelPromoCsvUploaded &&
		userLevelPromoState.productId.length > 0 &&
		userLevelPromoState.customerChannels.length > 0
	);
};
